import { useAllTokens } from 'hooks/Tokens'
import { useMemo } from 'react'
import { Token } from 'types/portfolio'
import { isLPToken } from 'utils/isLPToken'
import { Address } from 'viem'

export function useTokensFromList(options?: { enabled?: boolean; enableLpTokens?: boolean }) {
  const allTokens = useAllTokens()

  const tokens = useMemo(() => {
    let tokenList = Object.values(allTokens)

    if (options?.enableLpTokens === false) {
      tokenList = tokenList.filter((token) => !isLPToken(token))
    }

    return tokenList.map((token) => ({
      id: token.address,
      address: token.address as Address,
      name: token.name,
      symbol: token.symbol,
      decimals: token.decimals,
      logoUri: token.logoURI,
    })) as Token[]
  }, [allTokens, options?.enableLpTokens])

  const isLoading = Object.keys(allTokens).length === 0

  return {
    data: options?.enabled === false ? [] : tokens,
    isLoading: options?.enabled === false ? false : isLoading,
  }
}
